import React from 'react';
import { Box, Typography, ButtonBase } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { commandDashboard } from '../commandDashboardTokens';
import type { JumpToRow } from '../types';

interface JumpToListProps {
  rows: JumpToRow[];
}

export const JumpToList: React.FC<JumpToListProps> = ({ rows }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        bgcolor: commandDashboard.color.innerCard,
        border: `1px solid ${commandDashboard.color.innerCardBorder}`,
        borderRadius: `${commandDashboard.radius.innerCard}px`,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ p: '14px 16px', borderBottom: `1px solid ${commandDashboard.color.dividerStrong}` }}>
        <Typography sx={{ fontSize: '14.5px', fontWeight: 700 }}>Jump to</Typography>
      </Box>
      {rows.map((row) => (
        <ButtonBase
          key={row.id}
          onClick={() => navigate(row.href)}
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            p: '11px 16px',
            borderBottom: `1px solid ${commandDashboard.color.dividerLight}`,
            transition: 'background-color 120ms ease',
            '&:hover': { bgcolor: commandDashboard.color.outerCard },
          }}
        >
          <Typography sx={{ flex: '1 1 auto', minWidth: 0, fontSize: '13.5px', fontWeight: 600, textAlign: 'left' }}>
            {row.label}
          </Typography>
          <Typography sx={{ fontSize: '12.5px', color: commandDashboard.color.inkSubtle, fontVariantNumeric: 'tabular-nums' }}>
            {row.meta}
          </Typography>
          <ChevronRight sx={{ fontSize: '16px', color: commandDashboard.color.inkFaint }} />
        </ButtonBase>
      ))}
    </Box>
  );
};
